import * as React from 'react';
import { Dialog } from "@alifd/next";
import doLog from './log';

const { useEffect } = React;


export default function Index ( props: any ) {
    const { visible,setVisible,iframeUrl, productId,  action} = props;

    const receiveMessageFromIframePage = ( event: { data: any; } ) => {
        const { data } = event;
        if ( data ) {
            if ( data.gotoUrl ) {
                let url = data.gotoUrl;
                if ( data.gotoUrl.indexOf( 'return_url' ) === -1 ) {
                    if ( data.gotoUrl.indexOf( '?' ) === -1 ) {
                        url += `?return_url=${encodeURIComponent( window.location.href )}`;
                    } else {
                        url += `&return_url=${encodeURIComponent( window.location.href )}`;
                    }
                }

                window.location.href = url;
            }
            if ( data.isClosePopup ) {
                setVisible( false );
            }
        }
    }

    useEffect( () => {
        window.addEventListener( "message",receiveMessageFromIframePage,false );
        doLog( '/sc.details.commonLogs',`productId=${productId}&action=${action}` );
    },[] )

    return (
        <Dialog
            title=''
            className='promotion-dialog'
            visible={visible}
            style={{
                width: "830px"
            }}
            footer={false}
            onClose={() => setVisible( false )}>
            <iframe src={iframeUrl} id="promotion-iframe" style={{
                height: '570px',
                width: '100%'
            }} scrolling="auto" />
        </Dialog>
    )
}
